var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3598 6.96935L6.19824 14.1309L9.86385 17.7965L17.0254 10.635L13.3598 6.96935Z",
    fill: "#091E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51249 18.1675C4.22449 19.1755 4.80049 19.7755 5.83249 19.4875L9.12049 18.5515L5.44849 14.8555L4.51249 18.1675Z",
    fill: "#091E42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1279 6.50303L17.4959 4.87103C16.9439 4.31903 16.0319 4.31903 15.4559 4.87103L14.0879 6.23903L17.7599 9.91103L19.1279 8.54303C19.7039 7.96703 19.7039 7.05503 19.1279 6.50303Z",
    fill: "#091E42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ed935168abf6ec9fcf7142772785487f.svg";
export { ForwardRef as ReactComponent };